'use client';
import Dashboard from "@/components/pages/dashboard";
import { DashboardLinks } from "@/components/pages/dashboard/constants";
import OrderTracking from "@/components/pages/dashboard/pages/order-tracking";
import React, { useEffect } from "react";
import { TasticComponentProps } from "../types";
import { Props } from "./types";
import { useCartConfig } from "@/providers/cart-config/CartConfigContext";
import { useRouter } from 'next/navigation';
import { useLocale } from 'next-intl';

const OrderTrackingTastic = ({ data }: TasticComponentProps<Props>) => {
    const locale = useLocale();
    const router = useRouter();
    const { isCartEnabled, isLoading } = useCartConfig();
    useEffect(() => {
        if (!isLoading && !isCartEnabled) {
            router.push(`/${locale}/`);
        }
    }, [isCartEnabled, isLoading, router, locale]);
    return (
        <Dashboard href={DashboardLinks.orderTracking}>
            <OrderTracking data={data?.data?.dataSource} />
        </Dashboard>
    )
}

export default OrderTrackingTastic